export const isTokenExpiringSoon = (token) => {
  try {
    if (!token) return true;
    
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expirationTime = payload.exp * 1000;
    const currentTime = Date.now();
    const timeUntilExpiry = expirationTime - currentTime;
    
    // Return true if token expires in less than 5 minutes OR is already expired
    return timeUntilExpiry < 5 * 60 * 1000;
  } catch (error) {
    console.error('Error checking token expiration:', error);
    return true; // Assume expired if we can't parse
  }
};

// ✅ ADD: Get token expiration time in milliseconds
const getTokenExpirationTime = (token) => {
  try {
    if (!token) return null;
    
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000; // Convert to milliseconds
  } catch (error) {
    console.error('Error getting token expiration:', error);
    return null;
  }
};

// Calculate when to refresh token (default: 5 min before expiration)
export const calculateRefreshTime = (token, refreshBeforeMinutes = 5) => {
  try {
    if (!token) return null;
    
    const expirationTime = getTokenExpirationTime(token);
    if (!expirationTime) return null;
    
    const currentTime = Date.now();
    const timeUntilExpiry = expirationTime - currentTime;
    const refreshTime = timeUntilExpiry - (refreshBeforeMinutes * 60 * 1000);
    
    // ✅ FIX: If token is expired, refresh immediately
    if (timeUntilExpiry <= 0) {
      return 0;
    }
    
    // If already past refresh time but token not expired, refresh soon
    if (refreshTime <= 0) {
      return 60 * 1000; // 1 minute minimum to prevent loops
    }

    // Don't refresh too soon (min 1 minute to prevent loops)
    return Math.max(refreshTime, 60 * 1000);
  } catch (error) {
    console.error('Error calculating refresh time:', error);
    return null;
  }
};

 